<template>
    <img :src="mnbg" alt="Imagen de fondo" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;opacity: 0.05;z-index: -1;">
        <div class="container-fluid" style="margin-top: 100px">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex justify-content-center pb-5">
                        <img :src="a1" class="img-fluid" style="max-height: 300px;" data-aos="flip-left">
                    </div>
                </div>
                <div class="col-12">
                    <div class="row mb-5 mx-lg-5 mx-2" data-aos="flip-left">
                        <div v-for="(card_t, index) in cards_t" :key="index" class="col-lg-3 col-md-6 col-12 d-flex align-items-start mb-4">
                            <a class="d-flex h-100 w-100 blog_border bg-white text-decoration-none" @click="router.push('/detalles');">
                                <div class="d-flex flex-column text-start shadow">
                                    <a href="" class="">
                                        <img :src="card_t.img" class="" style="width: 100%; height: 170px; object-fit: cover; object-position: center; border-radius: 8px;">
                                    </a>
                                    <div class="d-flex flex-column m-4">
                                        <div class="description-xxs epilogue-regular text-dark">
                                            {{ card_t.text }}
                                        </div>
                                        <div class="">
                                            <div class="d-flex justify-content-around align-items-center text-dark description-sx epilogue-semibold my-2">
                                                {{ card_t.title }}
                                                <img :src="chat" class=" blog_arrow">
                                                {{ card_t.chat }}
                                                <img :src="eye" class=" blog_arrow">
                                                {{ card_t.vista }}
                                            </div>
                                            <div class="text-dark description-xxxs mx-1">
                                                {{ card_t.date }}...
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex justify-content-center pb-5">
                        <img :src="b5" class="img-fluid w-100" style="max-height: 300px;" data-aos="flip-left">
                    </div>
                </div>
            </div>
        </div>
</template>

<script setup>
    import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"

    import mnbg from "ASSETS/images/vectormn"
    import magda1 from "ASSETS/images/magda1"
    import magda2 from "ASSETS/images/magda3"
    import magdamn from "ASSETS/images/magdamn"

    import banner from "ASSETS/images/banner"

    import chat from "ASSETS/icons/chat1"
    import eye from "ASSETS/icons/eye"

    import a1 from "ASSETS/images/talleres/25"
    import a2 from "ASSETS/images/talleres/26"
    import a3 from "ASSETS/images/talleres/27"
    import a4 from "ASSETS/images/talleres/28"
    import b1 from "ASSETS/images/talleres/29"
    import b2 from "ASSETS/images/talleres/30"
    import b3 from "ASSETS/images/talleres/31"
    import b4 from "ASSETS/images/talleres/32"

    import b5 from "ASSETS/images/talleres/33"

    const router = useRouter()

    const cards_t = [
		{ img: a1, text: "2 horas diseñadas con el objetivo que el infante de 5 años y su mamá tomen un taller de Robótica Educativa durante el ciclo escolar. El alumno de pre-escolar conocerá a través un taller didáctico como usar esa tecnología, y así pasar más tiempo durante su último año de estancia con mamá en el Centro de Readaptación Social Santa Martha Acatitla Femenil.", title: "INFANCIAS EN MÉXICO" ,chat: "12", vista: "43", date: "September 10, 2021 " },
        { img: a2, text: "Se realiza mensualmente una producción de 2 a 3hrs de entretenimiento cultural itinerante en el sistema penitenciario de la CDMX desde el año 2013.", title: "CARAVANA CULTURAL ITINERANTE" ,chat: "12", vista: "43", date: "September 10, 2021 " },
		{ img: a3, text: "Programa de 3 días que reúne artesanos, artistas, músicos, cantautores independientes invitando al público interesado a disfrutar y a contribuir consumiendo y asistiendo a estos espacios itinerantes de nuestro México.", title: "FESTIVAL DE LA CARAVANA CULTURAL AMBULANTE" ,chat: "12", vista: "43", date: "September 10, 2021 " },
		{ img: a4, text: "Realización de eventos de pequeño formato, ejemplo: Exposiciones, Bazares Culturales, etc.", title: "GESTIÓN Y ORGANIZACIÓN DE EVENTO" ,chat: "12", vista: "43", date: "September 10, 2021 " },
        { img: b1, text: "Evento cultural y deportivo en la Penitenciaría de Santa Martha (23 de abril de 2016). Participación del equipo de baloncesto Camaleones en favor de la reinserción social.", title: "Reinserción social a través del arte y el deporte" ,chat: "12", vista: "43", date: "September 10, 2021 " },
        { img: b2, text: "Taller educativo en la Biblioteca José Manuel Otón con niños de primaria (28 de marzo). Actividades creativas para trabajar emociones.", title: "Taller de emociones con marionetas" ,chat: "12", vista: "43", date: "September 10, 2021 " },
		{ img: b3, text: "Taller impartido por Mariel Ramírez Castillo en El Rule Comunidad de Saberes. Herramientas digitales para impulsar la cultura.", title: "Marketing digital en proyectos culturales" ,chat: "12", vista: "43", date: "September 10, 2021 " },
		{ img: b4, text: "Programas confirmados para 2024 con #PozosDeVida, #IMJUVE y #BibliotecasPopulares.", title: "Alianzas interinstitucionales" ,chat: "12", vista: "43", date: "September 10, 2021 " },
	]


</script>



<style lang="scss" scoped>

</style>
